import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import BootstrapTooltip from "./BootstrapTooltip";
function CustomDataTableSearch({
  dataDetailTitle = "",
  dataDetailName = "",
  dataDetailColumns = [
    {
      header: "",
      field: "",
      body: (rowData) => null,
      sortable: false,
      filter: false,
      hidden: false,
    },
  ],
  data = [],
  columns = [
    {
      header: "",
      field: "",
      body: (rowData) => null,
      sortable: false,
      width: "",
    },
  ],
  onRefreshData = function() {},
  onSelectedData = function() {},
}) {
  const [expandedRows, setExpandedRows] = useState(null);
  const [filters, setFilters] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const dt = useRef(null);

  useEffect(() => {
    initFilters();
  }, [expandedRows]);

  const clearFilter = () => {
    initFilters();
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  const initFilters = () => {
    const filtersTmp = { ...filters };
    filtersTmp["global"] = { value: null, matchMode: FilterMatchMode.CONTAINS };
    if (typeof columns !== "undefined") {
      columns.map((column, index) => {
        if (column.filter === true) {
          filtersTmp[`${column.field}`] = {
            operator: FilterOperator.AND,
            constraints: [
              { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            ],
          };
        }
      });
    }
    setFilters(filtersTmp);
    setGlobalFilter("");
  };
  const header = (
    <div className="table-header">
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <span className="p-input-icon-left float-md-right mx-1 my-1">
            <i className="pi pi-search" />
            <InputText
              type="search"
              value={globalFilter}
              onChange={onGlobalFilterChange}
              placeholder="Global Search"
            />
          </span>
          <BootstrapTooltip title="Refresh Filter Criteria">
            <button
              type="button"
              className="btn btn-label-brand btn-sm btn-pill btn-bold float-md-right mx-1 my-1"
              onClick={() => {
                setGlobalFilter("");
                dt.current.reset();
                clearFilter();
              }}
            >
              <i className="pi pi-filter-slash"></i>
              Clear
            </button>
          </BootstrapTooltip>
        </div>
      </div>
    </div>
  );
  return (
    <div className="card datatable-responsive">
      <DataTable
        id="datatablesearch"
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowExpansionTemplate={(rowData) => (
          <React.Fragment>
            {dataDetailName !== "" ? (
              <React.Fragment>
                <h5>{dataDetailTitle}</h5>
                <DataTable value={rowData[dataDetailName]}>
                  {dataDetailColumns.map((column, index) => (
                    <Column
                      headerStyle={{ display: "" }}
                      key={index}
                      header={column.header}
                      field={column.field}
                      body={column.body}
                      sortable={column.sortable}
                      filter={column.filter}
                      hidden={column.hidden}
                    />
                  ))}
                </DataTable>
              </React.Fragment>
            ) : null}
          </React.Fragment>
        )}
        header={header}
        globalFilter={globalFilter}
        filters={filters}
        filterDisplay="menu"
        responsiveLayout="scroll"
        value={data}
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={10}
        selectionMode="single"
        onSelectionChange={(e) => onSelectedData(e.value, e.originalEvent)}
        rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 500, 1000, 5000, 10000]}
        paginatorLeft={
          <BootstrapTooltip title="Refresh Data">
            <Button
              type="button"
              icon="pi pi-refresh"
              className="p-button-text"
              onClick={() => {
                onRefreshData();
              }}
            />
          </BootstrapTooltip>
        }
        paginatorRight={
          <Button type="button" icon="pi pi-cloud" className="p-button-text" />
        }
        ref={dt}
        stripedRows
        size="small"
        //className="p-datatable-sm p-datatable-striped p-datatable-responsive"
        emptyMessage="You have no data at this time"
      >
        {columns.map((column, index) => (
          <Column
            key={index}
            header={column.header}
            field={column.field}
            body={column.body}
            sortable={column.sortable}
            style={{
              width: `${
                column.field === "select" ? "80px" : `${column.width}`
              }`,
              whiteSpace: `${column.field === "select" ? "nowrap" : null}`,
            }}
            filter={column.filter}
            filterPlaceholder={`🔍 ${column.header}`}
            hidden={column.hidden}
          />
        ))}
      </DataTable>
    </div>
  );
}

export default CustomDataTableSearch;
